import React from 'react';
import {
  FlatList,
  RefreshControl,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import {Icon} from '../Icon';

import Text from './Text';

type FlatListMenuItemProps = {
  item: {
    name: string;
    onPress?: () => void;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onPressItem: (item: any) => void;
};

export function FlatListMenuItem({item, onPressItem}: FlatListMenuItemProps) {
  return (
    <TouchableOpacity
      onPress={() => (item.onPress ? item.onPress() : onPressItem(item))}
      style={styles.item}>
      <View style={styles.itemInside}>
        <Text style={styles.itemText}>{item.name}</Text>
        <Icon name="chevron-right" size={12} color={styles.icon.color} />
      </View>
    </TouchableOpacity>
  );
}

const FlatListMenuItemSeparator = () => <View style={styles.separator} />;

type FlatListMenuProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
  onRefresh?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onPressItem: (item: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  flatlistRef?: any;
  contentContainerStyle?: StyleProp<ViewStyle>;
};

export default function FlatListMenu({
  data,
  onRefresh,
  onPressItem,
  flatlistRef,
  contentContainerStyle,
}: FlatListMenuProps) {
  return (
    <FlatList
      refreshControl={
        onRefresh ? <RefreshControl refreshing={false} onRefresh={onRefresh} /> : undefined
      }
      data={data}
      renderItem={({item}) => <FlatListMenuItem item={item} onPressItem={onPressItem} />}
      style={styles.flatList}
      contentContainerStyle={contentContainerStyle}
      ItemSeparatorComponent={FlatListMenuItemSeparator}
      ref={flatlistRef}
    />
  );
}

const styles = StyleSheet.create({
  item: {
    paddingVertical: 16,
    marginHorizontal: 8,
  },
  itemInside: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemText: {
    fontSize: 16,
    color: 'black',
  },
  flatList: {},
  icon: {
    color: 'grey',
  },
  separator: {
    borderBottomWidth: 1,
    borderBottomColor: 'lightgrey',
    marginHorizontal: 8,
  },
});
